<template>
  <div>
    <div
      v-for="phone in phones"
      :key="phone.id"
      data-qa="contacts-item-phone"
      class="text-body-1 mb-3"
      :class="isMobile ? 'text--text' : 'text-secondary--text'"
    >
      <template v-if="phone.description">
        {{ transDynamic(phone, `description,${language},${needTranslate}`) }}
      </template>

      <a
        v-if="isMobile"
        class="link-decoration-none primary--text"
        :href="`tel:${phone.phone_number_link}`"
      >
        {{ phone.phone_number }}
      </a>

      <span
        v-else
        class="text--text"
      >
        {{ phone.phone_number }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/info/contacts/types'
import { useContextStore } from 'src/store'
import transDynamic from 'djanjucks/filters/transDynamic'

const { context }: ContextStore = useContextStore()

const isMobile = computed(() => context?.flavour === 'mobile')

const { language } = I18NextVue
const needTranslate = context.feature_flags.pd_l10n_footer_pages

defineProps<{
  phones: ContextStore['context']['company_contacts'][number]['phones']['all']
}>()
</script>
